/*
  INTOVENT | 今すぐ購入するボタン

  商品フォームの内容をそのまま /cart/add に送り、成功したらカートページへ遷移する。
  Shopify標準の「動的チェックアウトボタン」はカートを飛ばして決済画面へ直行するが、
  こちらはカートに入れたうえでカートページを見せる挙動。
*/
if (!customElements.get('intovent-buy-now')) {
  customElements.define(
    'intovent-buy-now',
    class IntoventBuyNow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.productForm = this.closest('product-form');
        this.form = this.productForm?.querySelector('form');
        if (!this.button || !this.form) return;

        this.button.addEventListener('click', this.onClick.bind(this));
      }

      get redirectUrl() {
        return this.dataset.redirectUrl || window.routes?.cart_url || '/cart';
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        this.productForm?.handleErrorMessage?.();
        this.setLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(this.form);

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.productForm?.handleErrorMessage?.(response.description || response.message);
              this.setLoading(false);
              return;
            }
            // 遷移が始まるまでボタンはローディングのままにしておく
            window.location = this.redirectUrl;
          })
          .catch((error) => {
            console.error(error);
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-busy', isLoading);
        this.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
